import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { BlockCacheSubprovider, default as Web3ProviderEngine, DefaultFixtureSubprovider, InflightCacheSubprovider, SanitizerSubprovider, SubscriptionSubprovider } from '@bitski/provider-engine';
import { ProviderError } from './errors/provider-error';
import { NonceTrackerSubprovider } from './subproviders/nonce-tracker';
import { TransactionValidatorSubprovider } from './subproviders/transaction-validator';
import { TypedDataSanitizerSubprovider } from './subproviders/typed-data';
export var BitskiEngine = /*#__PURE__*/function (_Web3ProviderEngine) {
  _inherits(BitskiEngine, _Web3ProviderEngine);

  var _super = _createSuper(BitskiEngine);

  function BitskiEngine(options) {
    var _this;

    _classCallCheck(this, BitskiEngine);

    _this = _super.call(this, options);
    options = options || {}; // Handles static responses

    _this.addProvider(new DefaultFixtureSubprovider()); // Monitors requests to eth_getTransactionCount and eth_sendTransaction to track
    // pending transactions


    _this.addProvider(new NonceTrackerSubprovider()); // Sanitizes transaction params, removing anything invalid


    _this.addProvider(new SanitizerSubprovider());

    var enableValidator = !(options && options.disableValidation === true);

    if (enableValidator) {
      // Ensures that transactions are well formed (nonce, gas, gasPrice, from) before they are sent to Bitski
      _this.addProvider(new TransactionValidatorSubprovider(options.minGasPrice));

      _this.addProvider(new TypedDataSanitizerSubprovider());
    }

    var enableCache = !(options && options.disableCaching === true);

    if (enableCache) {
      // Block Cache - caches certain requests by their block number
      _this.addProvider(new BlockCacheSubprovider());
    } // Handles subscriptions and filters


    var filterAndSubsSubprovider = new SubscriptionSubprovider(); // Watch for updates from subscriptions

    filterAndSubsSubprovider.on('data', function (_, notification) {
      _this.onMessage(notification);
    });

    _this.addProvider(filterAndSubsSubprovider);

    if (enableCache) {
      // Debounces duplicate requests that occur at the same time
      _this.addProvider(new InflightCacheSubprovider());
    }

    return _this;
  }

  _createClass(BitskiEngine, [{
    key: "supportsSubscriptions",
    value: function supportsSubscriptions() {
      return this._pollForBlocks;
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      var subscribeMethod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'eth_subscribe';
      var subscriptionMethod = arguments.length > 1 ? arguments[1] : undefined;
      var parameters = arguments.length > 2 ? arguments[2] : undefined;

      if (!this._pollForBlocks) {
        return Promise.reject(ProviderError.SubscriptionsUnavailable());
      }

      parameters.unshift(subscriptionMethod);
      return this.send(subscribeMethod, parameters);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(subscriptionId) {
      var _this2 = this;

      var unsubscribeMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'eth_unsubscribe';

      if (!this._pollForBlocks) {
        return Promise.reject(ProviderError.SubscriptionsUnavailable());
      }

      return this.send(unsubscribeMethod, [subscriptionId]).then(function (response) {
        if (response) {
          _this2.removeAllListeners(subscriptionId);
        }

        return response;
      });
    }
  }, {
    key: "onMessage",
    value: function onMessage(notification) {
      // Re-emit (previous behavior ~ web3 1.0.0-beta.37)
      this.emit('data', null, notification);

      if (notification && notification.params && notification.params.subscription) {
        // Current web3 behavior - emit subscription id
        this.emit(notification.params.subscription, notification.params);
      }
    }
  }]);

  return BitskiEngine;
}(Web3ProviderEngine);